import { LoanStatusExternal } from '@nemuru-eng/js-api-client';

export const LOAN_STATUS_EXTERNAL_VALUES = [
  LoanStatusExternal.INITIAL,
  LoanStatusExternal.ON_HOLD,
  LoanStatusExternal.APPROVED,
  LoanStatusExternal.CONFIRMED,
  // LoanStatusExternal.PAID,
];
